import { Box } from "@react-three/flex";
import BioBox from "../Boxes/BioBox";
import GeoFlex from "./GeoFlex";
import TxtFlex from "./TxtFlex";


function BioFlex({scale, handleThreshold}) {

  return (
    <>
      <Box
        dir='column'
        justify='center'
        align='center'
        // marginLeft={9 * scale}
      >
        <Box
          dir='row'
          justify='center'
          align='center'
          margin={scale}
          marginLeft={11 * scale}
        >
          <TxtFlex 
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            justify='center'
            text={'Hello World!\n'}
            textTwo= {`I\'m Joseph,\n`}
            txtColorOne='#7E0000'
            txtColorTwo='white'
            textScaleFactor={scale * 0.85}
            textAlign='right'
          />
        </Box>
        <Box
          dir='column'
          justify='center'
          align='center'
          marginTop={4 * scale}
          marginLeft={12 * scale}
        >
          <TxtFlex 
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            justify='center'
            txtColorOne='white'
            txtColorTwo='white'
            textScaleFactor={scale * 0.45}
            textAlign='right'
            text={
              `I was drawn to software development by the opportunities.\n
            Not the obvious financial benefits and job security\n
            (which are certainly perks), but the opportunities to build,\n
            to challenge myself daily, and to never stop learning\n
            I really enjoy immersive design, bug hunting and green tests.\n\n
            As a Musician, I developed a passion for patterns\n\n and language at a very young age.\n
            This transitioned perfectly into software development.\n
            In my free time I enjoy playing music, cooking food,\n
            and all things outdoors.\n`
          }
            />
        </Box>
        <Box
          marginBottom={scale}
        >
          <GeoFlex
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            color='red'
            sphere        
          />
        </Box>
        <Box
          centerAnchor
          dir='row'
          justify='center'
          align='center'
        >
          <TxtFlex 
            scale={scale}
            onReflow={handleThreshold}
            align='center'
            text= {'Certified mixologist\n\nOrdained officiant\n\nAvid adventurer\n\n Lifelong learner\n\n'}
            txtColorOne='white'
            txtColorTwo='#7E0000'
            textScaleFactor={0.55 * scale}
            textAlign='center'
            // justify='flex-start'
          />
        </Box>
      </Box>
    </>
  );
};

export default BioFlex;